import { combineReducers } from 'redux';
import tableManagementGroupReducer from './group';
import tableManagementMapReducer from './map';
import tableManagementReportReducer from './report';
import tableManagemenVoidItemReducer from './voidItem';
import tableManagementSubscriptionReducer from './tableManagementSubscription';

export default combineReducers({
  group: tableManagementGroupReducer,
  map: tableManagementMapReducer,
  report: tableManagementReportReducer,
  tableManagementSubscription: tableManagementSubscriptionReducer,
  voidItem: tableManagemenVoidItemReducer,
});
